import React from 'react';

export const Trash = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 22C5.44772 22 5 21.5523 5 21V8H3V6H8V3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3V6H21V8H19V21C19 21.5523 18.5523 22 18 22H6ZM14 4H10V6H14V4ZM17 8H9H7V20H17V8ZM11 18V10H9V18H11ZM15 18V10H13V18H15Z"
      fill="currentColor"
    />
  </svg>
);
